import { Link, NavLink } from "react-router";
import { Markdown } from "../components/Markdown";
import { Wordmark } from "../components/ui";
import { t } from "../i18n";
import termos from "../../../../docs/legal/TERMOS-DE-USO.md?raw";
import privacidade from "../../../../docs/legal/POLITICA-DE-PRIVACIDADE.md?raw";

/** Páginas públicas com os textos legais. A fonte única é docs/legal; a versão vem do próprio documento. */
export function Legal({ doc }: { doc: "termos" | "privacidade" }) {
  const source = doc === "termos" ? termos : privacidade;
  return (
    <div className="legal-wrap">
      <header className="legal-head">
        <Link to="/entrar" className="legal-brand" aria-label={t.legal.backToSignIn}>
          <Wordmark />
        </Link>
        <nav className="legal-nav" aria-label={t.legal.navLabel}>
          <NavLink to="/termos">{t.legal.terms}</NavLink>
          <NavLink to="/privacidade">{t.legal.privacy}</NavLink>
        </nav>
      </header>
      <main className="legal-body">
        <Markdown source={source} />
      </main>
      <footer className="legal-foot ink2">
        <span>{t.brand.legalFooter}</span>
        <Link to="/entrar">{t.legal.backToSignIn}</Link>
      </footer>
    </div>
  );
}
